import React, { Component } from 'react';
import { CardBody, Collapse, Row, Col, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import propTypes from 'prop-types';

import { perPageOptions } from '../../../constants/kickavenue';

/**
 * Kick Point Redemption list filters.
 * The admin list endpoint (GET /admins/kick-point-redemptions) only supports the
 * `active` filter + pagination. Search/sort are intentionally omitted until the BE
 * adds support (see KB-5189 plan). Do not add dead controls here.
 */
export default class Filters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: props.active,
      per_page: props.per_page,
    }
    this._handleChange = this._handleChange.bind(this);
    this._handleChangeAndApply = this._handleChangeAndApply.bind(this);
    this._handleApply = this._handleApply.bind(this);
  }

  _handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  _handleChangeAndApply(e) {
    this.setState({ [e.target.name]: e.target.value }, () => this._submit());
  }

  _handleApply(e) {
    e.preventDefault();
    this._submit();
  }

  _submit() {
    const { active, per_page } = this.state;
    this.props.onApplyFilter({ active, per_page });
  }

  componentDidUpdate(prevProps) {
    if (this.props.isReset && prevProps.isReset !== this.props.isReset) {
      const { active, per_page } = this.props;
      this.setState({ active, per_page });
      this.props.onResetFilterCallback();
    }
  }

  render() {
    return (
      <Collapse isOpen={this.props.isOpen}>
        <CardBody className="filter-container__card-body">
          <Form className="form-filter" onSubmit={this._handleApply}>
            <Row>
              <Col xs={12} md={6}>
                <p>Filter By :</p>
                <div className="d-flex" style={{ padding: "0px 1rem" }}>
                  <FormGroup className="d-flex" style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                    <Label className="mb-2" style={{ fontWeight: 700 }}>
                      Active
                    </Label>
                    <div className="d-flex ml-2 mr-2">
                      <FormGroup check className="mr-2">
                        <Label check>
                          <Input type="radio" name="active" value="" checked={this.state.active == ''} onChange={this._handleChange} /> All
                        </Label>
                      </FormGroup>
                      <FormGroup check className="mr-2">
                        <Label check>
                          <Input type="radio" name="active" value="true" checked={this.state.active == 'true'} onChange={this._handleChange} /> Active
                        </Label>
                      </FormGroup>
                      <FormGroup check className="mr-2">
                        <Label check>
                          <Input type="radio" name="active" value="false" checked={this.state.active == 'false'} onChange={this._handleChange} /> Inactive
                        </Label>
                      </FormGroup>
                    </div>
                  </FormGroup>
                </div>
                <FormGroup className="mb-2" style={{ paddingLeft: '1rem' }}>
                  <Button color="primary">Apply Filter</Button>
                </FormGroup>
              </Col>
            </Row>
          </Form>
          <hr />
          <Form inline className="form-filter">
            <FormGroup className="mb-2 mr-3">
              <Label className="mr-sm-3">
                Show
              </Label>
              <Input
                type="select"
                name="per_page"
                onChange={this._handleChangeAndApply}
                value={this.state.per_page}
              >
                {perPageOptions.map((option, i) => <option value={option.value} key={i}>{option.label}</option>)}
              </Input>
            </FormGroup>
          </Form>
        </CardBody>
      </Collapse>
    )
  }
}

Filters.propTypes = {
  active: propTypes.string,
  per_page: propTypes.oneOfType([propTypes.number, propTypes.string]),
  isOpen: propTypes.bool.isRequired,
  onApplyFilter: propTypes.func.isRequired,
}

Filters.defaultProps = {
  active: '',
  per_page: 15,
}
